import { render, staticRenderFns } from "./browser.html?vue&type=template&id=0ddbda05&scoped=true&external"
import script from "./browser.js?vue&type=script&lang=js&external"
export * from "./browser.js?vue&type=script&lang=js&external"
import style0 from "./browser.scss?vue&type=style&index=0&id=0ddbda05&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddbda05",
  null
  
)

export default component.exports